import React from "react";
import "./livraison-hero.css";

// Same hero visual as the main NOCTUA RIVIERA home page — Monaco harbor at night.
// High-quality WebP served locally to avoid external URL fragility.
import { HERO_IMAGE as HERO_IMG } from "../lib/siteImages";

export const LivraisonHeroMedia = () => {
  return (
    <div
      className="absolute inset-0 pointer-events-none"
      aria-hidden="true"
      data-testid="livraison-hero-media"
    >
      <img
        src={HERO_IMG}
        alt=""
        width="1280"
        height="896"
        fetchPriority="high"
        className="livraison-hero-visual"
        data-testid="livraison-hero-poster"
      />
      <div className="livraison-hero-shade" />
    </div>
  );
};
